import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../config';
import '../styles/TermsAndConditions.css';

function TermsAndConditions({ onBack }) {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${config.apiUrl}/api/legal/terms-conditions`);
      setContent(response.data);
      setError(null);
    } catch (err) {
      console.error('Error fetching terms and conditions:', err);
      setError('Failed to load terms and conditions. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="terms-conditions-container">
        <div className="terms-conditions-header">
          <button className="back-button" onClick={onBack}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 12H5"/>
              <path d="M12 19l-7-7 7-7"/>
            </svg>
          </button>
          <h2>Terms and Conditions</h2>
        </div>
        <div className="terms-conditions-content">
          <div className="loading-state">
            <div className="loading-spinner"></div>
            <p>Loading terms and conditions...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="terms-conditions-container">
        <div className="terms-conditions-header">
          <button className="back-button" onClick={onBack}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 12H5"/>
              <path d="M12 19l-7-7 7-7"/>
            </svg>
          </button>
          <h2>Terms and Conditions</h2>
        </div>
        <div className="terms-conditions-content">
          <div className="error-state">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
            <p>{error}</p>
            <button onClick={fetchContent} className="retry-button">Try Again</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="terms-conditions-container">
      <div className="terms-conditions-header">
        <button className="back-button" onClick={onBack}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 12H5"/>
            <path d="M12 19l-7-7 7-7"/>
          </svg>
        </button>
        <h2>{content?.title || 'Terms and Conditions'}</h2>
      </div>

      <div className="terms-conditions-content">
        <div className="terms-intro">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="terms-icon">
            <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
            <path d="M14 2v6h6"/>
            <line x1="16" y1="13" x2="8" y2="13"/>
            <line x1="16" y1="17" x2="8" y2="17"/>
            <line x1="10" y1="9" x2="8" y2="9"/>
          </svg>
          {content?.updatedAt && (
            <p className="last-updated">
              Last Updated: {new Date(content.updatedAt).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </p>
          )}
          {content?.version && (
            <p className="version-info">Version {content.version}</p>
          )}
        </div>

        <div 
          className="dynamic-content"
          dangerouslySetInnerHTML={{ __html: content?.content || '' }}
        />
      </div>
    </div>
  );
}

export default TermsAndConditions;
